<template>
  <wrapper-swiper :options="swiperOptions">
    <div class="swiper-slide">
      <quick-access-card
        to="Receipt"
        icon="fas fa-money-check-alt"
      >
        Recibos Nómina
      </quick-access-card>
    </div>

    <div class="swiper-slide">
      <quick-access-card
        href="https://sisvia.iusa.com.mx/"
        icon="fas fa-suitcase"
      >
        Reg. gastos de viaje
      </quick-access-card>
    </div>

    <div class="swiper-slide">
      <quick-access-card
        href="https://normatividad.iusa.com.mx"
        icon="fas fa-copy"
      >
        Normatividad
      </quick-access-card>
    </div>

    <div class="swiper-slide">
      <quick-access-card
        to="MeetingRoom"
        icon="fas fa-users"
      >
        Reservación<br>
        Sala<br>
        Juntas
      </quick-access-card>
    </div>

    <div class="swiper-slide">
      <quick-access-card
        to="PhoneBook"
        icon="fas fa-book"
      >
        Directorio
      </quick-access-card>
    </div>

    <div class="swiper-slide">
      <quick-access-card
        :href="'https://capacita.iusa.com.mx/acceso.valida.php?u=' + user.employee_code"
      >
        <img
          src="img/logo_capacita.svg"
          alt="Logo IUSA Capacita"
        >
      </quick-access-card>
    </div>

    <div class="swiper-slide">
      <quick-access-card
        href="https://www.tiendaiusa.com/"
      >
        <img
          src="img/logo_tienda_iusa.svg"
          alt="Logo Tienda IUSA"
        >
      </quick-access-card>
    </div>
  </wrapper-swiper>
</template>

<script>
import { mapGetters } from "vuex";
import QuickAccessCard from '../QuickAccessCard.vue';
import WrapperSwiper from '../WrapperSwiper.vue';

export default {
  components: {
    QuickAccessCard,
    WrapperSwiper
  },

  data() {
    return {
      swiperOptions: {
        spaceBetween: 20,
        watchOverflow: true,
        breakpoints: {
          576: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1500: { slidesPerView: 5 },
          1920: { slidesPerView: 7 },
        },
      },
    };
  },

  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
  },
}
</script>